module.exports = __webpack_public_path__ + "img/温控系列.856aa2f8.jpg";